export enum ClaimColumn {
  CLAIM_ID = 'CLAIM_ID',
  FILL_DATE = 'FILL_DATE',
  DRUG_NAME = 'DRUG_NAME',
  NDC = 'NDC',
  QUANTITY = 'QUANTITY',
  REBATE_AMOUNT = 'REBATE_AMOUNT',
  REBATE_PERCENT = 'REBATE_PERCENT',
  ADMIN_AMOUNT = 'ADMIN_AMOUNT',
  ADMIN_PERCENT = 'ADMIN_PERCENT',
  SUBMISSION_DATE = 'SUBMISSION_DATE',
  WAC_UNIT_PRICE = 'WAC_UNIT_PRICE',
  STATUS = 'STATUS',
  STATUS_340B = 'STATUS_340B',
  STATUS_DISPUTED = 'STATUS_DISPUTED',
  STATUS_APPROVED = 'STATUS_APPROVED',
  REASON_CODES = 'REASON_CODES',
  PRESCRIBER_NPI = 'PRESCRIBER_NPI',
  PRESCRIBER_NAME = 'PRESCRIBER_NAME',
  PHARMACY_NPI = 'PHARMACY_NPI',
  PHARMACY_NAME = 'PHARMACY_NAME',
  DATE_OF_SERVICE = 'DATE_OF_SERVICE',
  PLAN_ID = 'PLAN_ID',
  PLAN_NAME = 'PLAN_NAME',
  PLACE_OF_SERVICE = 'PLACE_OF_SERVICE',
  ENTITY_TYPE_340B = 'ENTITY_TYPE_340B',
  CE_ID_340B = 'CE_ID_340B',
  REASON_340B = 'REASON_340B',
  LINE_OF_BUSINESS = 'LINE_OF_BUSINESS',
  SERVICE_PROVIDER_NPI = 'SERVICE_PROVIDER_NPI',
  CLAIM_TYPE = 'CLAIM_TYPE',
  STATE = 'STATE',
  RX_NUMBER = 'RX_NUMBER',
  UPLOAD_DATE = 'UPLOAD_DATE'
}
